__turbopack_context__.v({
  "secondary-color-css": "ComplaintStepper-module-scss-module__X66I4G__secondary-color-css",
});
